import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import EventIcon from '@mui/icons-material/Event';

import { WizardStep } from 'components/shared/WizardStepper';

export type LeaveRequestStepSlug = 'personal-details' | 'employment-details' | 'event-info' | 'summary';

const wizardSteps: Map<LeaveRequestStepSlug, WizardStep> = new Map([
  [
    'personal-details',
    {
      label: 'Personal Details',
      icon: PersonOutlineIcon,
      slug: 'personal-details',
      next: 'employment-details',
    },
  ],
  [
    'employment-details',
    {
      label: 'Employment Details',
      icon: PersonOutlineIcon,
      slug: 'employment-details',
      next: 'event-info',
      prev: 'personal-details',
    },
  ],
  [
    'event-info',
    {
      label: 'Event Info',
      icon: EventIcon,
      slug: 'event-info',
      next: 'summary',
      prev: 'employment-details',
    },
  ],
  [
    'summary',
    {
      label: 'Summary',
      icon: DescriptionIcon,
      slug: 'summary',
      prev: 'event-info',
    },
  ],
]);

export default wizardSteps;
